import React from 'react'

import { ContentSection } from 'src/common/components/ContentSection/ContentSection'
import {
  EnumTypographyVariants,
  Typography,
} from 'src/common/components/Typography/Typography'
import { Resume } from 'src/graphql/types'

import { ResumesCards } from './ResumesCards/ResumesCards'
import { ResumesTags } from './ResumesTags/ResumesTags'

import s from './DomainOrSkillResumes.module.scss'

export type DomainOrSkillResumesProps = {
  resumes: Array<Resume>
  skillName: string
  developersCount: number
}

export const DomainOrSkillResumes: React.FC<DomainOrSkillResumesProps> = ({
  resumes,
  skillName,
  developersCount,
}) => {
  return (
    <ContentSection className="container">
      <Typography
        className={s.DomainOrSkillResumes__title}
        variant={EnumTypographyVariants.H3}
      >
        {`Hire the TOP 3% of ${skillName} developers`}
      </Typography>

      <ResumesTags />
      <ResumesCards
        resumes={resumes}
        skillName={skillName}
        developersCount={developersCount}
      />
    </ContentSection>
  )
}
